import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const ThreeDModelingCard = () => {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };
    
    return (
        <Container >
      <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
                  3D Modeling and Animation Training
               </h3>
               <p className="c-para">Bring Ideas to Life in 3D </p>
               <p>The 3D Modeling & Animation Training at Choicest Fruit introduces learners to the creative 
                and technical world of digital design. Perfect for individuals seeking new skills or enhancing
                their portfolio, this program equips participants to build 3D environments, characters,
                and animations while developing the ability to apply these skills in real-world industries,
                 from gaming and advertising to architecture and engineering.</p>
            </div>
            <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What You’ll Learn'}                 
                  text={'Whether you’re an aspiring designer, animator, or engineer, you’ll gain the skills and confidence to bring your imagination into 3D reality.'}
                  button={'Register Here'}
               
                  link="https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform"
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Blender Fundamentals: Navigate Blender’s interface, use essential tools, and work effectively in a 3D design environment.'}
                  text2={'Modeling Skills: Start with primitive shapes and learn how to manipulate geometry and topology to build complex objects.'}
                  text3={'Texturing & Materials: Create and assign materials to objects, apply UV mapping, and add realistic surface details.'}
                  text4={'Lighting & Cameras: Position lights and cameras to establish shots, compose scenes, and prepare for rendering.'}
                  text5={'Rendering & Exporting: Understand rendering workflows and export high-quality images, videos, or interactive assets.'}
                  text6={'Animation Techniques: Rig and animate characters, objects, and environments for motion graphics, games, or film.'}
                  text7={'Special Effects: Explore fluid, smoke, particle, and soft body simulations to add realism and creativity to projects.'}
                  text8={'Sculpting & Drawing: Learn sculpting tools and digital drawing techniques for artistic detail.'}
                  text9={'Video Editing & Compositing: Edit videos and composite multiple elements for polished final outputs.'}
                  text10={'Python Scripting: Get an introduction to Python scripting for automating tasks and customizing workflows in Blender.'}
               />

               <Card
                  account={'Payment'}
                  amount={'$350'}
                  text={'A seamless and user-friendly payment integration.'}
                button={'Pay Here'}
                link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/CPB4XIVAF5UW5YZ3LKVOTUCJ"
              
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Training Length: 2 months.'}
                  text2={'Experience: No programming experience needed.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Training Setting: In-Person|Remote|Hybrid.'}
                  text5={'Software Requirements: No paid software required.'}
                  text6={'Training Requirements: Access to internet. A mouse with a scroll wheel (recommended for easier navigation in Blender)'}
                  text7={'Time Commitment: Willingness to dedicate time outside of sessions for practice and project completion.'}
                  text8={'Collaboration Mindset: Openness to working in teams, sharing feedback, and learning from peers.'}
                  text9={'Portfolio Development: Enthusiasm for building a portfolio of 3D projects during the training.'}
                  text10={'Career Goals: Interest in pursuing a career or further education in 3D design, animation, or related fields.'}
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}

const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default ThreeDModelingCard
